export default "__VITE_ASSET__c4b1d805__"